<template>
  <div class="vuse-content-wrapper">
    <v-container fluid class="text-center mt-5">
      <v-btn color="#71BEC8" class="white--text" rounded @click="deleteCache">{{$t('delete caches')}}</v-btn>
    </v-container>
  </div>
</template>
<script>
import {CLEAR_CACHE} from "@/store/modules/setting";
export default {
  name: "DeleteCache",

  methods: {
    deleteCache() {
      this.$store.dispatch(CLEAR_CACHE).then((data) => {
            if (data.data.status == 1) {
              this.$toasted.success('Delete successful!', {
                duration: 1000,
                position: 'top-right'
              })
            } else {
              alert(data.data.errors)
            }
          }
      );
    }
  }
}
</script>